import { useEffect } from "react";

const useRevealOnScroll = () => {
  useEffect(() => {
    const revealTargets = document.querySelectorAll("[data-reveal]");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.style.opacity = 1;
            e.target.style.transform = "translateY(0)";
          }
        });
      },
      { threshold: 0.12 }
    );

    revealTargets.forEach((t) => {
      t.style.opacity = 0;
      t.style.transform = "translateY(12px)";
      io.observe(t);
    });

    return () => io.disconnect();
  }, []);
};

export default useRevealOnScroll;
